import _AppBar from '@material-ui/core/AppBar';
import loadable from '@loadable/component';

import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import Brand from '@feedback/main/src/components/header/Brand';

import DomainNotFound from '@feedback/main/src/router/components/DomainNotFound';
import { getDomainName } from '@feedback/main/src/security/auth';

import { ExternalComplaint_query } from './__generated__/ExternalComplaint_query.graphql';

const AppBar = styled(_AppBar)`
  height: 66px;
  background: #fff;
  box-shadow: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Footer = styled.div`
  margin: 10px 0;
`;

const PrivacyWarning = styled.p`
  text-align: center;
  font-size: 12px;
`;

const LoadableExternalComplaintForm = loadable(
  () => import('./ExternalComplaintForm'),
);

type Props = {
  query: ExternalComplaint_query;
};
const ExternalComplaint = ({ query }: Props) => {
  const { company } = query;
  const { t } = useTranslation();

  if (!company) {
    return <DomainNotFound domainName={getDomainName()} />;
  }

  return (
    <>
      <AppBar position="static">
        <Brand company={company} withLink={false} />
      </AppBar>
      <ContentWrapper>
        <LoadableExternalComplaintForm company={company} query={query} />
      </ContentWrapper>
      <Footer>
        <PrivacyWarning>
          {t('Confidential and encrypted channel.')}
        </PrivacyWarning>
      </Footer>
    </>
  );
};

export default createFragmentContainer(ExternalComplaint, {
  query: graphql`
    fragment ExternalComplaint_query on Query   {
      company: companyDomainName {
        ...ExternalComplaintForm_company
        ...Brand_company
      }
      ...ExternalComplaintForm_query
    }
  `,
});
